export default "__VITE_ASSET__DXkEwgdB__"